// extracted by mini-css-extract-plugin
module.exports = {"EmptyState":"empty-state_EmptyState__vX1Fe","content":"empty-state_content__YLyxn"};